import * as types from '../constants/ActionTypes';

/**
 * ActionCreator to change the breadcrumb
 * @returns {{type}}
 */
export function changeBreadcrumbs(breadcrumbs) {
  return { type: types.CHANGE_BREADCRUMB, payload: breadcrumbs };
}



// WEBPACK FOOTER //
// ./actions/breadcrumbActions.js